<ng-container *ngTemplateOutlet="selected ? selected.content : null"></ng-container>
